import { CloseIcon } from '#assets/ReactSvg.ts';
import { IconButton } from './icon-button/IconButton.tsx';
import type { IconButtonProps } from './types.ts';

export function CloseButton({ size, title = 'Close', ...buttonProps }: IconButtonProps) {
  return (
    <IconButton title={title} height={size} width={size} {...buttonProps}>
      <CloseIcon />
    </IconButton>
  );
}
